function VariantButton({ props }) {
  return (
    <button
      disabled={props.disabled}
      onClick={props.onClick}
      className={`cursor-pointer font-bold w-full px-4 py-2 bg-[#34699A] text-white rounded-lg hover:bg-[#9EC6F3] shadow-lg ${
        props.disabled && "!bg-gray-200 !cursor-not-allowed"
      } ${props.selected && "!bg-white !text-[#34699A] border-[1px] border-[#34699A] "}`}
    >
      {props.title}
    </button>
  );
}

export default VariantButton;
